<template>
  <div class="modal" :class="{ 'is-active': shown }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-if="success"></p>
        <p class="modal-card-title" v-else>Nahrát práci do systému</p>
        <button class="btn spaceless isGray isCollapsed" @click="closeSelf()">
          <icon type="x" size="16"/>
        </button>
      </header>
      <section class="modal-card-body" v-if="success">
        <div class="result-box">
          <div class="result-circle result-success">
            <icon type="check" size="32"/>
          </div>
          <h3>Práce byla úspěšně nahrána.</h3>
        </div>
      </section>
      <section class="modal-card-body" v-else>
        <strong>Odkaz na digitální verzi maturitní práce</strong>
        <div class="control">
          <input v-model="thesisUrl" class="input" type="text" placeholder="https://">
        </div>
        <p class="help is-danger" :class="{'visible': error}">Zadaný řetězec není platným odkazem.</p>
      </section>
      <footer class="modal-card-foot">
        <div class="level" v-if="!success">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <button class="btn spaceless isGreen" @click="submit()">
                <icon type="check" size="16"/>Potvrdit
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import isUrl from 'is-url';

export default {
  props: ['shown', 'uuid'],

  data() {
    return {
      thesisUrl: '',
      success: false,
      error: false
    };
  },

  watch: {
    thesisUrl() {
      this.error = false;
    }
  },

  methods: {
    submit() {
      if (!isUrl(this.thesisUrl)) {
        this.error = true;
      } else {
        this.success = true;
        this.$emit('uploadThesis', {
          thesisUuid: this.uuid,
          thesisUrl: this.thesisUrl
        });
      }
    },

    closeSelf() {
      this.thesisUrl = '';
      this.success = false;
      this.$emit('closeSelf');
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/buttons.sass'

.modal-card-title
  margin-bottom: 0 !important

.modal-card-foot .level
  width: 100%

.modal-card-body strong
  display: block
  margin-bottom: .5rem

.help
  opacity: 0

.help.visible
  opacity: 1

.result
  height: 100%

  &, &-box, &-circle
    display: flex
    justify-content: center
    align-items: center

  &-box
    flex-direction: column

  &-circle
    width: 64px
    height: 64px
    border-radius: 50%
    color: white
    margin-bottom: 1rem

  &-success
    background: linear-gradient(to top, #23d160, #2de36d)
    box-shadow: 0px 2px 10px 3px rgba(#23d160 ,.2)
</style>

